<template>

<span class="text-warning" role="alert" >
    <strong>{{this.mesage}}</strong>
</span>

</template>

<script>
export default {
    name: "SimpleAlertComponent",
    props: ['mesage']
}
</script>

<style scoped>

</style>
